<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
    <v-container>
        <h1 class="text-h5 mb-2">
            {{ t('notFound.title') }}
        </h1>
        <p class="mb-4">
            {{ t('notFound.body') }}
        </p>
        <v-btn :to="{ name: 'courses' }" variant="tonal">
            {{ t('nav.back') }}
        </v-btn>
    </v-container>
</template>
